<template>
  <div v-if="callFetchApi && shouldVisible"></div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import Utility from "../helpers/utility";
import { keyMapsAction } from "../helpers/storeKeys";

export default {
  name: "DynamicApiWidgetNoUi",
  props: ["dataApi", "moduleProps"],
  data() {
    return {
      modulePropsData: {},
      shouldVisible: false,
      isStaticWidgetApi: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    fetchDataFromAPI() {
      let pageName = "";
      if (Utility.isCurrentlyAtUrl("cart-unified")) {
        pageName = "cart-unified";
      } else if (Utility.isCurrentlyAtUrl("login")) {
        pageName = "login";
      } else {
        pageName = "store";
      }

      let apiEndpoint = this.dataApi;
      if (
        apiEndpoint !== undefined &&
        apiEndpoint !== "undefined" &&
        apiEndpoint !== null &&
        apiEndpoint !== "null" &&
        apiEndpoint != false
      ) {
        let apiPayload = {
          endPoint: apiEndpoint.split("?")[0],
          site: (window?._siteProps_?.siteContext).toLowerCase(),
          lang: "en",
          platform: window?._siteProps_?.platform
            ? (window?._siteProps_?.platform).toLowerCase() === "web"
              ? "dt"
              : window?._siteProps_?.platform.toLowerCase()
            : "pwa",
          page: pageName,
          deliveryType: this.currentOrderType,
        };
        this.$store.dispatch(keyMapsAction.STATIC_WIDGET_API, apiPayload);
      }
    },
  },
  computed: {
    callFetchApi() {
      const orderType = this.$store.state.User.currentOrderType;
      if (orderType && !this.isStaticWidgetApi) {
        this.isStaticWidgetApi = true;
        this.fetchDataFromAPI();
      }
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
  },
};
</script>
